// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { Replay, ReplayT } from '../tbs/replay.js';


export class ReplayEnvelope implements flatbuffers.IUnpackableObject<ReplayEnvelopeT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ReplayEnvelope {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsReplayEnvelope(bb:flatbuffers.ByteBuffer, obj?:ReplayEnvelope):ReplayEnvelope {
  return (obj || new ReplayEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsReplayEnvelope(bb:flatbuffers.ByteBuffer, obj?:ReplayEnvelope):ReplayEnvelope {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ReplayEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

replay(obj?:Replay):Replay|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new Replay()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startReplayEnvelope(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addReplay(builder:flatbuffers.Builder, replayOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, replayOffset, 0);
}

static endReplayEnvelope(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createReplayEnvelope(builder:flatbuffers.Builder, replayOffset:flatbuffers.Offset):flatbuffers.Offset {
  ReplayEnvelope.startReplayEnvelope(builder);
  ReplayEnvelope.addReplay(builder, replayOffset);
  return ReplayEnvelope.endReplayEnvelope(builder);
}

unpack(): ReplayEnvelopeT {
  return new ReplayEnvelopeT(
    (this.replay() !== null ? this.replay()!.unpack() : null)
  );
}


unpackTo(_o: ReplayEnvelopeT): void {
  _o.replay = (this.replay() !== null ? this.replay()!.unpack() : null);
}
}

export class ReplayEnvelopeT implements flatbuffers.IGeneratedObject {
constructor(
  public replay: ReplayT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const replay = (this.replay !== null ? this.replay!.pack(builder) : 0);

  return ReplayEnvelope.createReplayEnvelope(builder,
    replay
  );
}
}
